import React from "react";
import { Button, dialog } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";

import excludeFields from "./components/ExcludeField";
import DialogCreate from "./components/DialogCreate";
import Table from "../../../components/Table";
import DialogDelete from "./components/DialogDelete";

import ResignationListPresenter from "./RequestListPresenter";
import RequestDetails from "./components/RequestDetails";
import { footer, html } from "framer-motion/m";
import DialogConfirmation from "./components/DialogConfirmation";

class RequestListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ResignationListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      showDetails: false,
      requestDetails: {},
      formData: {
        id: "",
        positionTitle: {},
        slotVacancy: 0,
        qualificationStandard: "",
        jobDescription: "",
        deadline: "",
      },
      password: {},
    };
  }

  getCollectionName() {
    return "request";
  }

  getToken() {
    return this.getParams().token;
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  handleSubmit = () => {
    this.presenter.handleSubmit(this.state.formData);
  };

  clickData(object, index) {
    this.setState({
      showFilters: true,
      showDetails: true,
      requestDetails: object,
    });
  }

  hideFilter() {
    this.setState({ showDetails: false });
  }

  onClickEdit() {
    const { objects } = this.state;
    this.presenter.onClickEdit(objects);
  }

  handleDelete() {
    const { requestDetails } = this.state;
    this.presenter.onClickDelete(requestDetails);
  }

  onSubmitPassword() {
    this.presenter.onSubmitPassword(this.state.password);
  }
  onChange(value, field) {
    this.setState((prevState) => ({
      password: {
        ...prevState.password,
        [field]: value,
      },
    }));
  }

  onClickAdd(object) {
    const schema = this.getSchemas();
    const formData = this.state.formData;

    dialog.fire({
      html: (
        <DialogCreate
          schema={schema}
          objects={object}
          onChangeData={this.onChangeObject.bind(this)}
          handleSubmit={this.handleSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onClickDelete() {
    const { requestDetails } = this.state;
    dialog.fire({
      html: (
        <>
          <DialogDelete
            requestDetails={requestDetails}
            clickDelete={this.handleDelete.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  onclickView() {
    const { requestDetails } = this.state;
    this.navigateTo(`/admin/job-details/view/${requestDetails?.id}`);
  }

  onSubmitApprove(object) {
    this.presenter.onSubmitApprove(object);
  }

  onSubmitReject(object) {
    this.presenter.onSubmitReject(object);
  }

  onHandleApprove(object) {
    // const { requestDetails } = this.state;
    // this.presenter.onHandleApprove(requestDetails);
    dialog.fire({
      html: (
        <DialogConfirmation
          handleConfirm={() => this.onSubmitApprove(object)}
          confirmationType="approve"
        />
      ),
      footer: false,
    });
  }

  onHandleReject(object) {
    // const { requestDetails } = this.state;
    // this.presenter.onHandleApprove(requestDetails);
    dialog.fire({
      html: (
        <DialogConfirmation
          handleConfirm={() => this.onSubmitReject(object)}
          confirmationType="reject"
        />
      ),
      footer: false,
    });
  }

  // onHandleReject() {
  //   const { requestDetails } = this.state;
  // }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      read: ["*", user.id],
      write: ["*", user.id],
    };
  }
  showFilter() {
    this.setState({ showFilters: true });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      selected,
      count,
      progress,
      requestDetails,
      formData,
      showFilters,
      showDetails,
    } = this.state;

    console.log("xzx");

    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex align-items-center justify-content-between">
                <h1 className="text-capitalize fw-bold">
                  {schema.label || this.getCollectionName()}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="text-nowrap fs-sm">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="text-nowrap fs-sm">{count}</span>
                </div>
              </div>
              <div className="d-flex justify-content-start">
                <p
                  className="align-self-end m-0 cursor-pointer fw-bold"
                  style={{ color: `#D18237` }}
                  onClick={this.showFilter.bind(this)}
                >
                  <i class="bi bi-filter"></i>Filters
                </p>
              </div>
              <div className="d-flex">
                {showFilters ? (
                  <div
                    className="d-flex flex-column me-2 w-50"
                    style={{
                      width: "50%",
                      position: "sticky",
                      top: 0,
                      alignSelf: "flex-start",
                      zIndex: 1,
                    }}
                  >
                    <div className="card p-3 mt-1">
                      <h6 className="fw-bold" style={{ color: "black" }}>
                        <i
                          className="bi bi-arrow-left cursor-pointer me-2"
                          onClick={this.hideFilter.bind(this)}
                        ></i>
                        Filters
                      </h6>

                      <div className="d-flex mt-3 d-flex flex-column gap-2">
                        {Object.keys(schema.filters || {}).map((field) => {
                          let { type, ...options } = schema.filters[field];
                          return (
                            <InputFactory
                              key={field}
                              className="ms-1"
                              type={type}
                              field={field}
                              where={{}}
                              onChange={this.onChangeFilter.bind(this, type)}
                              {...options}
                            />
                          );
                        })}
                        {/* <Search
                          schemas={this.getSchemas()}
                          className="mt-1"
                          onSubmit={this.searchSubmit.bind(this)}
                          fields={schema.fields}
                        /> */}
                      </div>
                    </div>
                    {showDetails && requestDetails && (
                      <RequestDetails
                        requestDetails={requestDetails}
                        clickView={this.onclickView.bind(this)}
                        handleApprove={() =>
                          this.onHandleApprove(requestDetails)
                        }
                        handleReject={() => this.onHandleReject(requestDetails)}
                      />
                    )}
                  </div>
                ) : (
                  ""
                )}

                <div className="w-100">
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
        {/* <div className="m-4 position-fixed bottom-0 end-0">
        <Button
        className="btn shadow-sm text-white"
        onClick={this.onClickAdd.bind(this)}
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "25px",
          backgroundColor: "#e09552",
        }}
        >
        <i className="bi bi-plus-lg" />
        </Button>
      </div> */}
      </>
    );
  }
}

export default withRouter(RequestListPage);
